import { styled } from 'goober';
import type { ReactNode } from 'react';

interface TableWrapperProps {
  children: ReactNode;
  className?: string;
  id?: string;
}

export const TableWrapper = ({
  children,
  className,
  id,
}: TableWrapperProps) => {
  return (
    <StyledTableWrapper id={id} className={className}>
      {children}
    </StyledTableWrapper>
  );
};

const StyledTableWrapper = styled('div')`
  padding: 0px 30px;
  overflow: auto;
  flex: 1;
  min-height: 0;
  ${({ theme }) => theme.mixins.scrollbar}
`;
